import { useTranslations } from 'next-intl';
import { NoGames } from '../NoGames/NoGames';

type EmptyFavouriteGamesProps = {
  namespace: string;
  pathname: string;
  className?: string;
};

function EmptyFavouriteGames(props: EmptyFavouriteGamesProps) {
  const { namespace, pathname, className } = props;
  const t = useTranslations(namespace);

  return (
    <NoGames
      className={className}
      title={t('title')}
      paragraph={t('empty_favourite_games.paragraph')}
      buttonText={t('empty_favourite_games.explore_games')}
      buttonHref={pathname}
      data-track-name="Explore"
    />
  );
}

export { EmptyFavouriteGames, type EmptyFavouriteGamesProps };
